module.exports = __webpack_public_path__ + "static/colouring_in_kerry_thumb_2-bc190fcd5340b688dcb391b85ae2f79c.jpg";